import { render, staticRenderFns } from "./CustomerAddressSelector.vue?vue&type=template&id=22452c88&scoped=true"
import script from "./CustomerAddressSelector.vue?vue&type=script&lang=js"
export * from "./CustomerAddressSelector.vue?vue&type=script&lang=js"
import style0 from "./CustomerAddressSelector.vue?vue&type=style&index=0&id=22452c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22452c88",
  null
  
)

export default component.exports